import { useParams } from "react-router-dom";
import api from "../../globals/axios";
import { useState, useEffect } from "react";
import LoaderContainer from "../../components/LoaderContainer";
import CustomAppBar from "../../components/AppBar";
import {
  CustomLabel,
  CustomTitle,
  CustomValue,
} from "../../components/Custom/CustomTypography";
import { useTranslation } from "react-i18next";
import { Typography, Container, Box, Grid } from "@mui/material";
import CustomDetailedList from "../../components/Custom/CustomDetailedList";

const ProgramDetailedView = () => {
  const { programId } = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const { t } = useTranslation();

  const loadProgramDetails = async () => {
    setLoading(true);
    try {
      const result = await api.get(
        `/programs/all-programs/?program_id=${programId}`
      );
      setData(result.data);
    } catch (err) {
      console.log(
        "Error: " +
          (err.response?.data?.non_field_errors?.[0] || "Something went wrong")
      );
    } finally {
      setLoading(false);
    }
  };

  const programDetails = data?.program_inputs?.[0]
    ? [
        {
          label: t("Program Name"),
          value: data.name,
        },
        {
          label: t("Crops"),
          value: data.program_inputs[0].commodity?.name,
        },
        {
          label: t("Geographies"),
          value: data.program_inputs[0].states?.name,
        },
        {
          label: t("Cost to farmer"),
          value: `${data.program_inputs[0].farmer_cost} Rs. per acre`,
        },
        {
          label: t("GHG"),
          value: `${data.program_inputs[0].ghg} per acre`,
        },
        {
          label: t("Water"),
          value: `${data.program_inputs[0].water} per acre`,
        },
        {
          label: t("Program end date"),
          value: data.program_inputs[0].program_end_date,
        },
      ]
    : [];

  useEffect(() => {
    loadProgramDetails();
  }, [programId]);

  return (
    <>
      <LoaderContainer loading={loading}>
        <CustomAppBar />
        <Container maxWidth="xs" mt={2}>
          <CustomTitle>{t(`${data?.name}`)}</CustomTitle>

          <Box mt={2}>
            <CustomLabel>{t("Program Details -")}</CustomLabel>

            <Box mt={2}>
              {programDetails.map(({ label, value }, index) => (
                <Grid container spacing={2} key={index}>
                  <Grid item xs={6}>
                    <CustomLabel>
                      <Typography variant="body1" fontWeight="bold">
                        {label}:
                      </Typography>
                    </CustomLabel>
                  </Grid>
                  <Grid item xs={6}>
                    <CustomValue>
                      <Typography variant="body1">{value}</Typography>
                    </CustomValue>
                  </Grid>
                </Grid>
              ))}
            </Box>
          </Box>

          {data?.program_inputs?.[0]?.program_tasks && (
            <Box mt={2}>
              <CustomLabel>{t("Program Tasks -")}</CustomLabel>

              <Box mt={2}>
                {data.program_inputs[0].program_tasks.map((programTask) => (
                  <CustomDetailedList
                    key={programTask.id}
                    id={programTask.id}
                    data={[
                      {
                        label: t("Activity Name"),
                        value: programTask.name,
                      },
                      {
                        label: t("Program start date"),
                        value: programTask.start_date,
                      },
                      {
                        label: t("Program end date"),
                        value: programTask.due_date,
                      },
                    ]}
                    buttonList={[]}
                  />
                ))}
              </Box>
            </Box>
          )}
        </Container>
      </LoaderContainer>
    </>
  );
};
export default ProgramDetailedView;
